import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logoConduto from '../../assets/img/logo-conduto.png';
import './Login.css';

const Login = ({ redirectTo = '/formulario' }) => {
  const [formData, setFormData] = useState({ usuario: '', clave: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const lastActivity = localStorage.getItem('lastActivity');
    const now = Date.now();

    if (token && lastActivity && (now - parseInt(lastActivity)) <= 900000) {
      navigate(redirectTo, { replace: true });
    }
  }, [navigate, redirectTo]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('https://apicv.conduto.com.ec/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.success) {
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('usuario', JSON.stringify(data.usuario));
        localStorage.setItem('lastActivity', Date.now().toString()); 
        navigate(redirectTo, { replace: true });
      } else {
        setError(data.message || 'Error en el login');
      }
    } catch (error) {
      console.error('Error:', error);
      setError('Error de conexión con el servidor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="login-page"
      style={{
        margin: 0,
        padding: 0,
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        minHeight: '100vh',
      }}
    >
      <div className="login-container">
        <div className="login-form">
          <div className="logo-section">
            <img src={logoConduto} alt="Logo Conduto" className="logo" />
          </div>

          <form onSubmit={handleSubmit}>
            <h2 style={{ color: '#004892' }}>Iniciar Sesión</h2>

            {error && <div className="alert alert-danger">{error}</div>}

            <div className="form-group">
              <label htmlFor="usuario">Usuario</label>
              <input
                type="text"
                id="usuario"
                name="usuario"
                value={formData.usuario}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="clave">Contraseña</label>
              <input
                type="password"
                id="clave"
                name="clave"
                value={formData.clave}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>

            <button type="submit" className="btn-login" disabled={loading}>
              {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;